import React from 'react'
import Home from '../../home/Home'
import Rent from '../../home/listings/rent/Rent'

const RentView = () => {
  return (
      <>
        <Home />
        <Rent />
       </>
  )
}

export default RentView
